(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sticky-product-bar')) return;

    class StickyProductBar extends HTMLElement {
      connectedCallback() {
        this.productId = this.dataset.productId;
        this.currentVariantId = this.dataset.currentVariantId;
        this.buttonAction = this.dataset.buttonAction;
        this.buttonText = this.dataset.buttonText || 'BUY NOW';
        this.soldOutText = this.dataset.soldOutText || 'Sold out';
        this.openCartOnAdd = this.dataset.openCartOnAdd === 'true';
        this.customThumbnail = this.dataset.customThumbnail === 'true';
        this.variantData = this.#readVariantData();

        this.error = this.querySelector('[data-spb-error]');
        this.thumb = this.querySelector('[data-spb-thumb] img');
        this.price = this.querySelector('[data-spb-price]');
        this.compare = this.querySelector('[data-spb-compare]');
        this.quantityWrap = this.querySelector('[data-spb-qty]');
        this.quantityValue = this.querySelector('[data-spb-qty-value]');
        this.decreaseButton = this.querySelector('[data-spb-dec]');
        this.increaseButton = this.querySelector('[data-spb-inc]');
        this.submitButton = this.querySelector('[data-spb-submit]');

        this.quantity = this.#getCurrentMin();

        this.#bindQuantityControls();
        this.#bindBundleListener();
        this.#syncFromMainForm();
        this.#setupScrollTrigger();
        this.#setupVariantListener();
        this.#setupSubmit();
        this.#renderQuantity();
      }

      disconnectedCallback() {
        this.#teardownObserver();
        document.removeEventListener('variant:update', this.handleVariantUpdate);
        document.removeEventListener('bundle:quantity', this.handleBundleQuantity);
      }

      #readVariantData() {
        try {
          return JSON.parse(this.querySelector('[data-spb-variants]')?.textContent || '[]');
        } catch (_) {
          return [];
        }
      }

      #getCurrentVariant() {
        return this.variantData.find((variant) => String(variant.id) === String(this.currentVariantId)) || null;
      }

      #getCurrentMin() {
        const variant = this.#getCurrentVariant();
        return Number(variant?.quantity_min || this.quantityWrap?.dataset.min || 1);
      }

      #syncFromMainForm() {
        const variantInput = document.querySelector('.product-information product-form-component input[name="id"]');
        if (variantInput instanceof HTMLInputElement && variantInput.value) {
          this.currentVariantId = variantInput.value;
          this.#applyVariantState();
        } else {
          this.#applyVariantState();
        }
      }

      #setupScrollTrigger() {
        const shouldTrigger = this.dataset.scrollTrigger === 'true';
        if (!shouldTrigger || this.classList.contains('is-visible')) return;

        const triggerTarget = document.querySelector('.product-information');
        if (!triggerTarget) {
          this.classList.add('is-visible');
          return;
        }

        this.triggerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
              this.classList.toggle('is-visible', scrolledPast);
            });
          },
          {
            threshold: 0
          }
        );

        this.triggerObserver.observe(triggerTarget);
      }

      #teardownObserver() {
        if (this.triggerObserver) {
          this.triggerObserver.disconnect();
        }
      }

      #setupVariantListener() {
        this.handleVariantUpdate = (event) => {
          const detail = event.detail;
          if (!detail || !detail.data) return;

          const eventProductId = String(detail.data.productId || '');
          if (eventProductId && this.productId && eventProductId !== String(this.productId)) return;

          if (!detail.resource?.id) return;

          this.currentVariantId = detail.resource.id;
          this.#applyVariantState(detail.resource);
        };

        document.addEventListener('variant:update', this.handleVariantUpdate);
      }

      #applyVariantState(resource = null) {
        const variant = this.#getCurrentVariant();
        const available = typeof resource?.available === 'boolean' ? resource.available : variant?.available;

        if (variant?.price_text && this.price) {
          this.price.textContent = variant.price_text;
        }

        if (this.compare) {
          if (variant?.compare_at_price_text) {
            this.compare.hidden = false;
            this.compare.textContent = variant.compare_at_price_text;
          } else {
            this.compare.hidden = true;
            this.compare.textContent = '';
          }
        }

        if (!this.customThumbnail && this.thumb && variant?.featured_media_url) {
          this.thumb.src = variant.featured_media_url;
        }

        if (this.quantityWrap) {
          this.quantityWrap.dataset.min = String(variant?.quantity_min || 1);
          this.quantityWrap.dataset.max = variant?.quantity_max ?? '';
          this.quantityWrap.dataset.step = String(variant?.quantity_increment || 1);
          this.quantity = Math.max(this.#getCurrentMin(), this.quantity);
          this.#renderQuantity();
        }

        if (this.submitButton) {
          this.submitButton.disabled = !available;
          this.submitButton.textContent = available ? this.buttonText : this.soldOutText;
        }
      }

      #bindQuantityControls() {
        if (!this.quantityWrap) return;

        this.decreaseButton?.addEventListener('click', () => {
          const step = Number(this.quantityWrap.dataset.step || 1);
          this.quantity = Math.max(this.#getCurrentMin(), this.quantity - step);
          this.#renderQuantity();
        });

        this.increaseButton?.addEventListener('click', () => {
          const step = Number(this.quantityWrap.dataset.step || 1);
          const max = Number(this.quantityWrap.dataset.max || 0);
          const nextQuantity = this.quantity + step;

          if (max > 0) {
            this.quantity = Math.min(max, nextQuantity);
          } else {
            this.quantity = nextQuantity;
          }

          this.#renderQuantity();
        });
      }

      /*
        The pack picker on the page owns the quantity. Without this the shopper could pick a
        2-pack, scroll, add from the sticky bar and silently get 1.
      */
      #bindBundleListener() {
        this.handleBundleQuantity = (event) => {
          const quantity = Number(event.detail?.quantity);
          if (!Number.isFinite(quantity) || quantity < 1) return;
          this.quantity = quantity;
          this.#renderQuantity();
        };

        document.addEventListener('bundle:quantity', this.handleBundleQuantity);
      }

      #renderQuantity() {
        if (!this.quantityValue || !this.quantityWrap) return;

        const min = this.#getCurrentMin();
        const max = Number(this.quantityWrap.dataset.max || 0);
        this.quantity = Math.max(min, this.quantity);
        if (max > 0) this.quantity = Math.min(max, this.quantity);

        this.quantityValue.textContent = String(this.quantity);

        if (this.decreaseButton) {
          this.decreaseButton.disabled = this.quantity <= min;
        }

        if (this.increaseButton) {
          this.increaseButton.disabled = max > 0 ? this.quantity >= max : false;
        }
      }

      #setupSubmit() {
        this.submitButton?.addEventListener('click', () => this.#handleSubmit());
      }

      #setError(message = '') {
        if (!this.error) return;

        if (message) {
          this.error.textContent = message;
          this.error.classList.add('is-visible');
        } else {
          this.error.textContent = '';
          this.error.classList.remove('is-visible');
        }
      }

      #handleSubmit() {
        if (!this.currentVariantId || !this.submitButton || this.submitButton.disabled) return;

        this.#setError('');
        this.submitButton.disabled = true;

        const formData = new FormData();
        formData.append('id', this.currentVariantId);
        formData.append('quantity', String(this.quantity || 1));

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [];
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });

        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
        }

        fetch((window.Theme?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'text/html'
          },
          body: formData
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.#setError(response.message || 'Unable to add this item to the cart.');
              this.#applyVariantState();
              return;
            }

            if (this.buttonAction === 'buy_now') {
              window.location.href = '/checkout';
              return;
            }

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  sourceId: String(this.currentVariantId),
                  data: {
                    source: 'product-form-component',
                    itemCount: Number(this.quantity || 1),
                    productId: this.productId,
                    sections: response.sections
                  }
                }
              })
            );

            if (this.openCartOnAdd) {
              document.querySelector('cart-drawer-component')?.showDialog?.();
            }

            this.#applyVariantState();
          })
          .catch(() => {
            this.#setError('Unable to add this item to the cart.');
            this.#applyVariantState();
          });
      }
    }

    customElements.define('sticky-product-bar', StickyProductBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
